// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SEPADDPrenotificationEmailEditController = function ($scope, $rootScope, $routeParams, DocumentEmailTemplate,
    EmailTemplatePlaceholder, gettext, gettextCatalog, SEPADDSettings, Features) {
    EmailEditControllerBase('SEPADDPrenotification', $scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog);
    $scope.sepaddSettings = SEPADDSettings.get();
    var baseSave = $scope.save;
    $scope.save = function () {
        $scope.sepaddSettings.$update({}, function () {
            baseSave();
        });
    };

    $scope.features = Features.features;
};
SEPADDPrenotificationEmailEditController.$inject = ['$scope', '$rootScope', '$routeParams', 'DocumentEmailTemplate',
    'EmailTemplatePlaceholder', 'gettext', 'gettextCatalog', 'SEPADDSettings', 'Features'];
